require('./bootstrap');

import {createApp, h} from 'vue';
import { App, plugin } from '@inertiajs/inertia-vue3';
import { Link } from '@inertiajs/inertia-vue3'
// import { Inertia } from '@inertiajs/inertia'
import ZComm from './Modules/z-comm'
import ZUtil from './Modules/z-util'
import { InertiaProgress } from '@inertiajs/progress'
import WaveUI from 'wave-ui'

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';



import 'wave-ui/dist/wave-ui.css'
// import 'font-awesome/css/font-awesome.min.css'

const el = document.getElementById('app');

InertiaProgress.init();

const app = createApp({
    render: () => h(App, {
        initialPage: JSON.parse(el.dataset.page),
        resolveComponent: name => require(`./Pages/${name}`).default
    }),
    created() {
        this.$zcomm.app = this
        this.$zutil.app = this
    }
});

// Register a-la-carte components from the given list.
// this to move to the npm later, it's here now easier dev purposesss
import * as components from './Components'
for (let id in components) {
  const component = components[id]
  app.component(component.name, component)
}

new WaveUI(app, {
  // Some Wave UI options.
})

app.config.globalProperties.$route = window.route;
app.provide('$route', window.route);

app.config.globalProperties.$zcomm = new ZComm
app.config.globalProperties.$zutil = new ZUtil
app.config.globalProperties.api_service = process.env.MIX_API;
app.config.globalProperties.params = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});

import ZenOne from './Shared/ZenTwo'

app.use(plugin).use(VueSweetalert2)
.component('InertiaLink', Link)
.component('ZenOne', ZenOne)
.component('Layout', ZenOne)
.mount(el);
